// 👥 Employés E5 — Sous-bloc « Regroupements » (fiche conservée) et bandeau « Fiche archivée » (fiche regroupée).
import { Badge } from '@/components/ui/badge';
import { GitMerge } from 'lucide-react';

export function SousBlocRegroupements({ employee, onOuvrirFiche }) {
  const fusions = employee?.fusions || [];
  if (!fusions.length) return null;
  return (
    <div className="mt-4 border-t pt-4" data-testid="sous-bloc-regroupements">
      <p className="text-sm font-medium text-slate-700 mb-2 flex items-center gap-2"><GitMerge className="w-4 h-4" /> Regroupements</p>
      <ul className="text-xs text-slate-700 space-y-1">
        {fusions.map((f) => (
          <li key={f.fusion_id} className="flex flex-wrap items-center gap-2" data-testid={`regroupement-${f.autre_id}`}>
            <span>Fiche <strong>{f.autre_nom}</strong> archivée et intégrée le {f.date ? new Date(f.date).toLocaleDateString('fr-CA') : ''}</span>
            <button type="button" className="text-blue-600 hover:underline" onClick={() => onOuvrirFiche?.(f.autre_id)} data-testid={`regroupement-lien-${f.autre_id}`}>voir la fiche archivée</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function BandeauFicheArchivee({ employee, conservee, onOuvrirFiche }) {
  if (employee?.statut_fiche !== 'archivee_fusion') return null;
  return (
    <div className="border border-amber-300 bg-amber-50 rounded-lg p-3 text-sm text-amber-900 flex flex-wrap items-center gap-2" data-testid="bandeau-fiche-archivee">
      <Badge className="bg-amber-200 text-amber-900">Fiche archivée</Badge>
      <span>Regroupée dans <strong>{conservee ? `${conservee.prenom || ''} ${conservee.nom || ''}`.trim() : '…'}</strong>{employee.fusionnee_le ? ` le ${new Date(employee.fusionnee_le).toLocaleDateString('fr-CA')}` : ''} — lecture seule.</span>
      <button type="button" className="text-blue-700 hover:underline" onClick={() => onOuvrirFiche?.(employee.fusionnee_dans)} data-testid="bandeau-lien-conservee">ouvrir la fiche conservée</button>
    </div>
  );
}
